import { Injectable } from "@angular/core";
import { GeolocationService } from "@obg/ngx.core";

import { GeofencingConfigService } from "./geofencing.config";
import { GeofencingExperimentService } from "./geofencing.experiment.service";

@Injectable({ providedIn: "root" })
export class GeofencingService {
	constructor(
		private configService: GeofencingConfigService,
		private experimentService: GeofencingExperimentService,
		private geoLocationService: GeolocationService
	) {}

	isRouteExempt(route?: string): boolean {
		return route ? this.configService.getArgentinaGeoFenceExemptRoutes().includes(route) : false;
	}

	isArgentinaGeofencingEnabled(): boolean {
		return !this.experimentService.isGeofencingDisabled() && this.configService.isArgentinaGeofencingEnabled();
	}

	isBrazilGeofencingEnabled(): boolean {
		return this.geoLocationService.isBrazilGeofencingEnabled();
	}

	isAwsLocationServiceEnabled(): boolean {
		return !this.experimentService.isGeofencingDisabled() && this.configService.isAwsLocationServiceEnabled();
	}

	isWageringBlockDialogEnabled(): boolean {
		return this.configService.isWageringBlockDialogEnabled();
	}
}
